import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { DataService } from '../services/data.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-run-detail',
  templateUrl: './run-detail.component.html',
  styleUrls: ['./run-detail.component.css']
})
export class RunDetailComponent {
  selectedId: number = 0;
  run: any = {openSamples:false};
  reportFile: any;
  constructor(private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private dataService: DataService,
    private messageService: MessageService) {}

  ngOnInit() {
    //this.run = {id:123, startDate:Date.now(), endDate: Date.now(), runName: "testrun123", openSamples:true, allApproved:false};
    const id = this.route.snapshot.paramMap.get('runId');
    this.selectedId = +id!;
    this.loadData(this.selectedId);
    this.dataService.getRunReport(this.selectedId).then(data => {
      this.reportFile = this.sanitizer.bypassSecurityTrustHtml(data);
      //this.loading = false;
    });
    //this.multiQCFile = "";
    //runDetails = this.service.GetRunDetails(id);
  }
  
  approve(record: any){
    this.dataService.approveRun(record.runId)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Approved open samples on ' + record.name + ' successfully.'});
        this.loadData(this.selectedId);
      })
      .catch(error => {
        this.messageService.add({severity:'error', summary:'Open samples on run ' + record.name + ' could not be approved.'});
      });

  }

  retest(record: any){
    this.dataService.retestRun(record.runId)
      .then(data => {
        this.messageService.add({severity:'success', summary:'Retested open samples on ' + record.name + ' successfully.'});
        this.loadData(this.selectedId);
      })
      .catch(error => {
        this.messageService.add({severity:'error', summary:'Open samples on run ' + record.name + ' could not be retested.'});
      });

  }

  loadData(id: number){
    this.dataService.getRunDetail(id).then(data => {
      this.run = data;
    });
  }
}
